export const MD_MIN = '1'
export const MD_MAX = '1280'

export const LG_MIN = '1281'
export const LG_MAX = '1690'

export const SIDEBAR_MAX = '1490'
